import React from 'react';
import { ArrowUpRightIcon, CompassIcon, FileTextIcon, LayersIcon } from 'lucide-react';
const trustPrinciples = [{
  title: 'Coaches set direction',
  copy: 'Goals and next moves stay grounded in coach judgment.',
  Icon: CompassIcon
}, {
  title: 'Nisa handles synthesis',
  copy: 'It draws from coaching records and drafts the summaries.',
  Icon: FileTextIcon
}, {
  title: 'Leaders see themes',
  copy: 'A program view, without the conversations inside it.',
  Icon: LayersIcon
}];
export const Proof = () => {
  return <section id="proof" className="w-full border-y border-primary-100 bg-primary-50/40 py-10 md:py-14" data-id="element-264" data-mp="2oguxi5hgspgm">
    <div className="container mx-auto px-5 sm:px-8" data-id="element-265" data-mp="33dm1yt5zwrd3">
      <div className="mx-auto grid max-w-6xl gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-266" data-mp="2yg3ocph19nyr">
        <div className="lg:col-span-4" data-id="element-267" data-mp="2ydzmed2p2z14">
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.16em] text-primary-600" data-id="element-268" data-mp="1904a4tyk58c9">Trust by design</p>
          <h2 className="text-balance font-serif text-2xl font-normal leading-snug text-cyan-950" data-id="element-269" data-mp="1434eze38xpzx">
            At the heart of strong coaching teams is trust
          </h2>
          <a href="/security" className="group mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 underline decoration-primary-300 underline-offset-4 hover:text-primary-800" data-id="element-270" data-mp="6gb86w6ff2rx">
            Security and data practices
            <ArrowUpRightIcon className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" strokeWidth={1.75} aria-hidden="true" data-id="element-271" data-mp="g873jzh4oesg" />
          </a>
        </div>

        <div className="grid gap-6 sm:grid-cols-3 sm:gap-8 lg:col-span-8" data-id="element-272" data-mp="q38tuyn53mwm">
          {trustPrinciples.map(({
            title,
            copy,
            Icon
          }) => <div key={title} className="border-t border-primary-200 pt-4" data-id="element-273" data-mp="z5qgvfamcjko">
              <Icon className="h-[18px] w-[18px] text-primary-600" strokeWidth={1.75} aria-hidden="true" data-id="element-274" data-mp="2vxs48t4ebhy3" />
              <h3 className="mt-3 text-sm font-medium leading-snug text-cyan-900" data-id="element-275" data-mp="30wlduagkaosz">{title}</h3>
              <p className="mt-1.5 text-sm leading-snug text-gray-600" data-id="element-276" data-mp="823cjg6yxg3w">{copy}</p>
            </div>)}
        </div>
      </div>
    </div>
  </section>;
};